export default "__VITE_ASSET__tPD3d_zb__"